import React, { FocusEvent, FocusEventHandler, ReactNode } from 'react';
import { FOCUSABLE_SELECTOR, getFocusableChildren } from '../utils/focus';

export const FOCUS_TRAP_ATTR = 'data-focus-trap';

function FocusGuard({ onFocus }: { onFocus: FocusEventHandler }) {
  return (
    <div
      {...{ [FOCUS_TRAP_ATTR]: true }}
      tabIndex={0} // eslint-disable-line jsx-a11y/no-noninteractive-tabindex
      onFocus={onFocus}
      aria-hidden
      className="visually-hidden"
    />
  );
}

export function handleFocus(e: FocusEvent, forward: boolean) {
  e.preventDefault();

  if (!e.target.parentElement) {
    return;
  }

  const elements = getFocusableChildren(
    e.target.parentElement,
    `${FOCUSABLE_SELECTOR}:not([${FOCUS_TRAP_ATTR}])`,
  );

  const element = elements[forward ? 'shift' : 'pop']();
  element?.focus();
}

export default function FocusTrap({ children }: { children: ReactNode }) {
  function onFocusFirst(e: FocusEvent) {
    handleFocus(e, false);
  }

  function onFocusLast(e: FocusEvent) {
    handleFocus(e, true);
  }

  return (
    <div className="focus-trap">
      <FocusGuard onFocus={onFocusFirst} />
      {children}
      <FocusGuard onFocus={onFocusLast} />
    </div>
  );
}
